var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.401,
    height: 89.719,
    viewBox: "0 0 118.401 89.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6901",
    "data-name": "Group 6901",
    transform: "translate(-1073.999 -1242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8016",
    "data-name": "Path 8016",
    d: "M514.5,344.884H445.447l.212.533,5.16,12.829,62.969.051a28.825,28.825,0,0,1,3.549.415l-.131-.047V347.583A2.7,2.7,0,0,0,514.5,344.884Z",
    transform: "translate(666.385 902.012)",
    fill: "#e5e4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8017",
    "data-name": "Path 8017",
    d: "M347.024,336.715l-62.969-.051-5.16-12.829-2.182-5.429H246.575a5.721,5.721,0,0,0-5.724,5.725V402.4a5.723,5.723,0,0,0,5.724,5.724h106.95a5.726,5.726,0,0,0,5.727-5.724V348.546a11.885,11.885,0,0,0-8.679-11.417A28.832,28.832,0,0,0,347.024,336.715Zm10.957,58.622v4.272H242.131v-4.272Z",
    transform: "translate(833.148 923.594)",
    fill: "#f5f7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3806",
    "data-name": "Rectangle 3806",
    width: 115.851,
    height: 4.272,
    transform: "translate(1075.279 1318.931)",
    fill: "#e5e4f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.cf634a19bf35db8583e8aa16803358f5.svg";
export { ForwardRef as ReactComponent };